import { IsNotEmpty, IsUUID } from 'class-validator';

export class GetCreateParamsDto {
  @IsUUID()
  @IsNotEmpty()
  companyId: string;

  @IsUUID()
  @IsNotEmpty()
  employeeId: string;
}
